/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { Create, Edit, SimpleForm, useTranslate } from 'react-admin';
import ClientForm from './ClientForm';
import statusEnum from '../../enums/status.enum';

const ClientDetail = (props) => {
  const { actionType } = props;
  const translate = useTranslate();
  const statusLabel = translate('custom.general.status');
  const nameLabel = translate('custom.general.name');
  const themeLabel = translate('custom.clients.theme');
  return (
    <>
      {actionType === 'edit' ? (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <Edit {...props}>
          <SimpleForm>
            <ClientForm
              status={statusEnum}
              statusLabel={statusLabel}
              nameLabel={nameLabel}
              themeLabel={themeLabel}
            />
          </SimpleForm>
        </Edit>
      ) : (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <Create {...props}>
          <SimpleForm>
            <ClientForm
              status={statusEnum}
              statusLabel={statusLabel}
              nameLabel={nameLabel}
              themeLabel={themeLabel}
            />
          </SimpleForm>
        </Create>
      )}
    </>
  );
};

ClientDetail.propTypes = {
  actionType: PropTypes.string,
};

ClientDetail.defaultProps = {
  actionType: 'create',
};

export default ClientDetail;
